import BaseApiService from '../baseApi.service';

export default class ResetPasswordService extends BaseApiService {
  readonly basePath = 'users/v1';

  constructor(props = null) {
    super(props);
  }
}
